<template>
  <p>Registration for VIZBI 2010 has now closed.</p>
</template>
